<template>
  <div>
    <HeaderIconsForProcessingBasket :selectedItems="selectedItems" type="moveAllRequests" @getData="reloadPage"  @exportExcel="exportExcel"/>

    <div v-if="!this.$store.state.allLoading" style="margin-top: 40px">
      <div v-if="$store.state.views === 'cards'">
        <div v-if="this.$store.state.allData.length > 0" style="margin-top: 40px">
          <RequestsCard :CardData="this.$store.state.allData" @back="handleBack" v-if="!this.$store.state.allLoading"
            @pageCount="handlePageNumber" @getUsersName="getUsersName" />
          <div>
            <LoadingMore v-if="loadMoreData" style="margin: 40px" />
          </div>
        </div>
        <div v-else>
          <div>
            <button @click="handleBack" class="button__back">رجوع</button>
          </div>
          <div class="noData">لا يوجد بيانات</div>
        </div>
      </div>

      <div v-else-if="$store.state.views === 'table'" class="table__view">

        <GlobalTap @send-global-data="getTabOfGlobal" @startNewDesignSearch="startNewDesignSearch" />

        <!-- Tabs Options => Khaled  -->
         <v-row v-if="$store.state.showFilters">
           <v-col style="    padding-bottom: 0;" cols="9">
            <v-tabs class="tabs-container" style=" background: #fff;   ">
              <v-tab v-for="(tab, index) in tabs" :key="index" @click="selectedTab = index" class="tab-with-icon"
                style="min-width: 220px;">
                <v-icon :class="{'custom-txt-style-b-icon': true, 'custom-txt-style-b-icon-active': selectedTab === index }" >{{ tab.icon }}</v-icon>
                <span :class="{'custom-txt-style-b': true, 'custom-txt-style-b-active': selectedTab === index }" >{{ tab.label }}</span>
              </v-tab>
            </v-tabs>
  
           </v-col>
           <v-col style="    padding-bottom: 0;" cols="3">
              <div style="display: flex;justify-content: space-between;background-color: #fff;padding: 6px 13px;">
                <h4 style="">تصفية الطلبات</h4>
              <v-btn icon color="red" class="close-filters" @click="$store.state.showFilters = false"
                  style="float: left;display: block;position: inherit;">
                  <v-icon>mdi-close</v-icon>
                </v-btn>

              </div>
           </v-col>

         </v-row>

        <v-row>
          <v-col :cols="$store.state.showFilters ? 9 : 12" :sm="$store.state.showFilters ? 9 : 12"
            :md="$store.state.showFilters ? 9 : 12">
            <table-component :showSelect="true" itemKey="id" :selectedRows.sync="selected_requests" :headers="headers"
              :pagination="this.$store.state.pagination" :limit="$store.state.counterOfShow"
              :items="this.$store.state.tableData" :loading="loading" @refresh="getTableData" v-model="page">
              <template v-slot:[`item.action`]="{ item }">
                <v-menu offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn color="white" small depressed dark v-bind="attrs" v-on="on">
                      <v-icon style="background: rgb(63, 14, 64); border-radius: 4px">mdi-dots-vertical</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <AllSingleProcessForProcessingCSTable :item="item" @getUsersName="getUsersName" />
                  </v-list>
                </v-menu>
              </template>

              <template slot="item.quality_notes" slot-scope="props">
                <span v-if="!props.item.quality_notes"></span>
                <v-tooltip bottom v-else>
                  <template v-slot:activator="{ on }">
                    <span v-on="on">{{
                      props.item.quality_notes.length > 7
                        ? props.item.quality_notes.substring(0, 7) + "..."
                        : props.item.quality_notes
                    }}</span>
                  </template>
                  <div class="font-weight-bold">{{ props.item.quality_notes }}<br><b>({{ props.item.quacomment_date }})</b></div>
                </v-tooltip>
              </template>
              <!-- <template slot="item.customer_name" slot-scope="props">
                <span v-if="!props.item.customer_name"></span>
                <v-tooltip bottom v-else>
                  <template v-slot:activator="{ on }">
                    <span v-on="on">{{
                      props.item.customer_name.length > 7
                        ? props.item.customer_name.substring(0, 7) + "..."
                        : props.item.customer_name
                    }}</span>
                  </template>
                  <div class="font-weight-bold">{{ props.item.customer_mobile }}</div>
                </v-tooltip>
              </template> -->
              <template slot="item.source" slot-scope="props">
                <span v-if="!props.item.source"></span>
                <v-tooltip bottom v-else>
                  <template v-slot:activator="{ on }">
                    <span v-on="on">{{
                      props.item.source.length > 5
                        ? props.item.source.substring(0, 5) + "..."
                        : props.item.source
                    }}</span>
                  </template>
                  <div class="font-weight-bold">{{ props.item.source }}</div>
                </v-tooltip>
              </template>

              <template slot="item.type" slot-scope="props">
                <span v-if="props.item.type !== 'لا_يوجد'">{{ props.item.type }}</span>
                <span v-else style="color: red">{{ props.item.type }}</span>
              </template>

              <template slot="item.req_product_type" slot-scope="props">
                <span v-if="props.item.req_product_type !== 'لا_يوجد'" style="font-family: Dintext">{{ props.item.req_product_type }}</span>
                <span v-else style="color: red;font-family: Dintext">{{ props.item.req_product_type }}</span>
              </template>
              <template slot="item.status" slot-scope="props">
                <span v-if="props.item.status?.includes('مرفوض ')" class="faild__request">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <span v-on="on">{{
                        props.item.status.length > 7
                          ? props.item.status.substring(0, 7) + ".."
                          : props.item.status
                      }}</span>
                    </template>
                    <div class="font-weight-bold">{{ props.item.status }}</div>
                  </v-tooltip>
                </span>
                <span v-else-if="
                  props.item.status?.includes('طلب جديد') ||
                  props.item.status?.includes('طلب تم فتحه')
                " class="new__request">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <span v-on="on">{{
                        props.item.status.length > 8
                          ? props.item.status.substring(0, 8) + ".."
                          : props.item.status
                      }}</span>
                    </template>
                    <div class="font-weight-bold">{{ props.item.status }}</div>
                  </v-tooltip>
                </span>

                <span v-else-if="
                  props.item.status?.includes('مؤرشف') ||
                  props.item.status?.includes('مكتمل')
                " class="archive__request">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <span v-on="on">{{
                        props.item.status.length > 7
                          ? props.item.status.substring(0, 7) + ".."
                          : props.item.status
                      }}</span>
                    </template>
                    <div class="font-weight-bold">{{ props.item.status }}</div>
                  </v-tooltip>
                </span>
                <span v-else class="anotherTypes__request">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <span v-on="on">{{
                        props.item.status.length > 8
                          ? props.item.status.substring(0, 8) + ".."
                          : props.item.status
                      }}</span>
                    </template>
                    <div class="font-weight-bold">{{ props.item.status }}</div>
                  </v-tooltip>
                </span>
              </template>

              <template slot="item.agent_notes" slot-scope="props">
                <span v-if="!props.item.agent_notes"></span>
                <v-tooltip bottom v-else>
                  <template v-slot:activator="{ on }">
                    <span v-on="on">{{
                      props.item.agent_notes.length > 7
                        ? props.item.agent_notes.substring(0, 7) + "..."
                        : props.item.agent_notes
                    }}</span>
                  </template>
                  <div class="font-weight-bold">{{ props.item.agent_notes }}<br><b>({{ props.item.comment_date }})</b></div>
                </v-tooltip>
              </template>
            </table-component>
          </v-col>
          <v-col cols="3" sm="3" md="3">

            <!-- Tabs Content => Khaled  -->
            <!-- <div v-if="$store.state.showFilters" class="filters-block">
              <v-btn icon color="red" class="close-filters" @click="$store.state.showFilters = false"
                style="float: left;">
                <v-icon>mdi-close</v-icon>
              </v-btn>
              <div class="filters-content">
                <div v-show="selectedTab === 0">
                  <h4 style="margin-bottom: 10px;">تصفية الطلبات</h4>
                  <v-divider class="mb-4"></v-divider>
                  <RequestsTap @send-request-data="getTabOfRequest" />
                </div>
                <div v-show="selectedTab === 1">
                  <h4 style="margin-bottom: 10px;">التصنيفات</h4>
                  <v-divider class="mb-4"></v-divider>
                  <ClassificationsTap @send-classification-data="getTabOfClassification" />
                </div>
                <div v-show="selectedTab === 2">
                  <h4 style="margin-bottom: 10px;">بيانات العميل</h4>
                  <v-divider class="mb-4"></v-divider>
                  <CustomerTap @send-customer-data="getTabOfCustomer" />
                </div>
                <div v-show="selectedTab === 3">
                  <h4 style="margin-bottom: 10px;">الجودة</h4>
                  <v-divider class="mb-4"></v-divider>
                  <QualityTap @send-quality-data="getTabOfQuality" />
                </div>
                <div v-show="selectedTab === 4">
                  <h4 style="margin-bottom: 10px;">متوسط التمويل</h4>
                  <v-divider class="mb-4"></v-divider>
                  <FundingDurationTap @send-fundingDuration-data="getTabOfFundingDuration" />
                </div>
              </div>
            </div> -->

            <div v-if="$store.state.showFilters" class="filters-block" style="padding-top: 0px;">
              <!-- <v-btn icon color="red" class="close-filters" @click="$store.state.showFilters = false"
                style="float: left;">
                <v-icon>mdi-close</v-icon>
              </v-btn> -->
              <div class="filters-content">
                <v-tabs-items v-model="selectedTab">
                  <v-tab-item>
                    <!-- <h4 style="margin-bottom: 10px;">تصفية الطلبات</h4> -->
                    <!-- <v-divider class="mb-4"></v-divider> -->
                    <RequestsTap @send-request-data="getTabOfRequest" />
                  </v-tab-item>
                  <v-tab-item>
                    <h4 style="margin-bottom: 10px;">التصنيفات</h4>
                    <v-divider class="mb-4"></v-divider>
                    <ClassificationsTap @send-classification-data="getTabOfClassification" />
                  </v-tab-item>
                  <v-tab-item>
                    <h4 style="margin-bottom: 10px;">بيانات العميل</h4>
                    <v-divider class="mb-4"></v-divider>
                    <CustomerTap @send-customer-data="getTabOfCustomer" />
                  </v-tab-item>
                  <v-tab-item>
                    <h4 style="margin-bottom: 10px;">الجودة</h4>
                    <v-divider class="mb-4"></v-divider>
                    <QualityTap @send-quality-data="getTabOfQuality" />
                  </v-tab-item>
                  <v-tab-item>
                    <h4 style="margin-bottom: 10px;">متوسط التمويل</h4>
                    <v-divider class="mb-4"></v-divider>
                    <FundingDurationTap @send-fundingDuration-data="getTabOfFundingDuration" />
                  </v-tab-item>
                </v-tabs-items>
              </div>
            </div>

          </v-col>
        </v-row>
        <OrderRequestSection v-if="this.$store.state.openOrderRequestSection" style="margin-top: 50px" />
      </div>

      <div v-else-if="$store.state.views === 'default'">
        <div v-if="this.$store.state.allData.length > 0" style="margin-top: 40px">
          <DefaultView :CardData="this.$store.state.allData" @back="handleBack" v-if="!this.$store.state.allLoading"
            @pageCount="handlePageNumber" @getUsersName="getUsersName" />
          <div>
            <LoadingMore v-if="loadMoreData" style="margin: 40px" />
          </div>
        </div>
      </div>
    </div>
    <div style="
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 40px;
      " v-else>
      <LoadingMore />
    </div>
    <v-snackbar v-model="active" color="#40BE72" timeout="-1" right bottom class="ml-4" elevation="24"
      transition="fade-transition">
      <span class="font-weight-bold" style="font-size: 16px">{{ message }}</span>
      <template v-slot:action>
        <v-btn icon small @click="active = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>

    <AdminDialog @selectedValue="selectedValue" :items="allStatus" :label="label" />
    <AdministrationDialog @selectedAdministrationValue="selectedAdministrationValue" />
    <FilterDialogInAdmin pageName="all" />
    <OrderRequestDialog />
    <CallsDialog />
  </div>
</template>

<script>
import RequestsCard from "@/components/Charts/RequestsCard.vue";
import LoadingMore from "@/components/Charts/LoadingMore.vue";
import HeaderIconsForProcessingBasket from "@/components/Charts/HeaderIconsForProcessingBasket.vue";
import AdminDialog from "@/components/AdminComponent/AdminDialog.vue";
import AdministrationDialog from "@/components/AdminComponent/AdministrationDialog.vue";
import FilterDialogInAdmin from "@/components/Charts/FilterDialogInAdmin.vue";
import CallsDialog from "@/components/Charts/CallsDialog.vue";
import { formatDate } from "@/mixins/formatDate";
import { SourceValue } from "@/mixins/sourceValue";
import OrderRequestDialog from "@/components/AdminComponent/OrderRequestDialog.vue";
import OrderRequestSection from "@/components/AdminComponent/OrderRequestSection.vue";
import AllSingleProcessForProcessingCSTable from "@/views/admin/Requests/AllRequests/AllSingleProcessForProcessingCSTable.vue";
import { axiosInstance } from "@/axios/config";
import DefaultView from "@/components/Base/DefaultView.vue";
import { EventBus } from '@/mixins/eventBus.js';
import Axios from "axios";
import RequestsTap from "./RequestsTap.vue";
import ClassificationsTap from "./ClassificationsTap.vue";
import CustomerTap from "./CustomerTap.vue";
import QualityTap from "./QualityTap.vue";
import FundingDurationTap from "./FundingDurationTap.vue";

import { getRequestTabData } from "../../../../helper/requestTabHelper";
import { getClassificationTabData } from "../../../../helper/classificationTabHelper";
import { getCustomerTabData } from "../../../../helper/customerTabHelper";
import { getQualityTabData } from "../../../../helper/qualityTabHelper";
import { getFundingDurationTabData } from "../../../../helper/fundingDurationTabHelper";
import { getGlobalTapData } from "../../../../helper/globalTabHelper";
import GlobalTap from "./GlobalTap.vue";


export default {
  name: "AdminSupport",
  components: {
    OrderRequestDialog,
    OrderRequestSection,
    FilterDialogInAdmin,
    AdminDialog,
    AdministrationDialog,
    RequestsCard,
    LoadingMore,
    HeaderIconsForProcessingBasket,
    AllSingleProcessForProcessingCSTable,
    CallsDialog,
    DefaultView,
    RequestsTap,
    ClassificationsTap,
    CustomerTap,
    QualityTap,
    FundingDurationTap,
    GlobalTap
  },

  data() {
    return {
      body: {},
      allGetData: [],
      customers: [],
      search: '',
      selected_requests: [],
      pagination: {
        limit: 3,
        count: this.$store.state.searchedCount,
      },
      page: 1,
      selectedRows: [],
      allData: [],
      active: false,
      message: "",
      showSelect: { default: false },
      copySupportRequests: [],
      loadMoreData: false,
      count: null,
      loading: false,
      selectId: null,
      selected_products_list: [],
      allStatus: [],

      label: "",
      selectedItems: [],
      countPage: 1,
      listenToFreezeAction: this.$store.state.freezeActionIsDone,
      headers: [
        { align: "center", value: "data-table-select" },
        { text: "تاريخ الطلب", value: "created_at", width: "107px", align: "center" },
        { text: "نوع المنتج", value: "req_product_type", align: "center" },
        {
          text: "استشاري المبيعات",
          value: "استشاري المبيعات",
          align: "center",
        },
        { text: "عميل", value: "customer_name", align: "center" },
/*
        { text: "الجوال", value: "customer_mobile", align: "center" },
*/
        { text: "حالة الطلب", value: "status", width: "108px", align: "center" },
        {
          text: "مصدر المعامله",
          value: "source",
          align: "center",
        },
        {
          text: "تصنيف الاستشاري",
          value: "تصنيف الاستشاري",
          align: "center",
        },
        {
          text: "ملاحظه الاستشاري ",
          value: "agent_notes",
          width: "110px",
          align: "center",
        },
        {
          text: "ملاحظة الجوده",
          value: "quality_notes",
          width: "110px",
          align: "center",
        },
        {
          text: "تاريخ الاستشاري",
          value: "agent_date",
          width: "107px",
          align: "center",
        },
        {
          text: "استلام الجودة",
          value: "هل تم استلامه من قبل الجوده",
          align: "center",
        },
        {
          text: "تم التحديث ",
          value: "updated_at",
          width: "107px",
          align: "center",
        },

        {
          text: "وصف الطلب",
          value: "request_description",
          width: "107px",
          align: "center",
        },

        {
          text: "متي يظبط العميل وضعه",
          value: "situation_improve_date",
          width: "107px",
          align: "center",
        },

        { text: "", value: "action", align: "center" },
      ],

      selectedTab: 0,
      tabs: [
        { label: "تصفية الطلبات", icon: "mdi-filter" },
        { label: "التصنيفات", icon: "mdi-format-list-bulleted" },
        { label: "بيانات العميل", icon: "mdi-account" },
        { label: "الجودة", icon: "mdi-star" },
        { label: "متوسط التمويل", icon: "mdi-currency-usd" },
      ],

    };
  },

  watch: {
    page(val) {
      if (this.$store.state.isSearch === false && this.search == null) {

        this.getTableData(val);
      } else {

        this.searchRequest(val, "table");
      }
    },

    // search(newval,oldval){
    //   if(newval != oldval){
    //     // this.$store.state.bodySearch.delete("CustomerNameOrComment");
    //     // this.$store.state.bodySearch.append("CustomerNameOrComment", val);
    //     this.searchRequest(this.page, "table");
    //   }
    // },

    selected_requests(val) {
      this.selectedItems = val;
      this.$emit("requests", val);
    },



    "$store.state.reloaddata_after_action": {
      handler(newval, oldvalue) {
        console.log("reload_after_action changed")
        if (newval.action == 'admin_all_requests') {
          this.searchRequest(1, newval.view_type);
        }
      },
      immediate: true,
      deep: true
    },

    "$store.state.counterOfShow": {
      handler(newval, oldvalue) {
        if (newval !== oldvalue && !this.$store.state.admin_search_active) {
          this.getTableData(this.page);
        }
      },
    },

    $route: {
      immediate: true,
      handler(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.$store.state.counterOfShow = 10;
        }
      },
    },
  },

  beforeDestroy() {
    this.$store.state.openOrderRequestSection = false;
  },

  methods: {

    exportExcel() {
      const table = document.querySelector(".table__view table");
      this.exportTableToCsv(table, "جميع الطلبات");
    },

    startNewDesignSearch() {
      this.searchRequest(this.page, "table");
    },

    getTabOfRequest(val) {
      this.$store.state.RequestTapData = val;
      getRequestTabData(this.$store);
      console.log('tis.$store.state.RequestTapData')
      console.log(this.$store.state.RequestTapData);
    },

    getTabOfClassification(val) {
      this.$store.state.ClassificationTapData = val;
      getClassificationTabData(this.$store);
    },

    getTabOfCustomer(val) {
      this.$store.state.tabCustomerData = val;
      getCustomerTabData(this.$store);
    },

    getTabOfQuality(val) {
      this.$store.state.QualityTapData = val;
      getQualityTabData(this.$store);
    },

    getTabOfFundingDuration(val) {
      this.$store.state.FundingDurationTapData = val;
      getFundingDurationTabData(this.$store);
    },

    getTabOfGlobal(val) {
      this.$store.state.GlobalTapData = val;
      getGlobalTapData(this.$store);
    },











    getUsersName(users, label, requestId) {
      this.allStatus = users;
      this.label = label;
      this.selectId = requestId;
    },

    handleSearchFilter() {
      if (this.search != null && this.search != '' && this.search != undefined) {
        this.$store.state.bodySearch.delete("CustomerNameOrComment");
        this.$store.state.bodySearch.append("CustomerNameOrComment", this.search);
        this.$store.state.CustomerNameOrComment = this.search;
      } else {
        this.$store.state.bodySearch.delete("CustomerNameOrComment");
        this.$store.state.CustomerNameOrComment = '';
      }
      this.searchRequest(this.page, "table");
    },

    handleBack() {
      this.$store.state.allData = [];
      this.$store.state.tableData = [];
      this.allGetData = [];
      this.$store.state.followLoading = true;
      this.$store.state.isSearch = false;
      this.$store.state.back = false;
      this.getAllRequests(1);
    },

    reloadPage() {
      console.log("reloadPage emited");
      this.$store.state.allData = [];
      this.$store.state.tableData = [];
      this.allGetData = [];
      this.$store.state.followLoading = true;
      this.$store.state.isSearch = false;
      this.getAllRequests(1);
      this.$store.state.startElement = [];
    },

    getAgentRequest(itemSelected) {
      let body = new FormData();

      body.append("request_ids[0]", this.selectId);
      body.append("agents_ids[0]", itemSelected.id);
      body.append("move_reason", itemSelected.move_reason);

      axiosInstance
        .post(`/v2/employee/Requests/moveAllRequests`, body, {
          headers: this.request_headers(),
        })
        .then((res) => {
          this.active = true;
          this.message = res.data.message;
        })
        .catch((err) => {
          this.active = true;
          let error = { err };
          this.message = error.err.response.data.message;
        });
    },

    sendRequestToAdministration(itemSelected) {
      console.log('sendRequestToAdministration' + itemSelected)
      let body = new FormData();
      body.append("administration_comment", itemSelected);

      axiosInstance
        .post(`/v2/employee/Requests/moveToAdministration/${this.$store.state.administrationRequestId}`, body, {
          headers: this.request_headers(),
        })
        .then((res) => {
          this.active = true;
          this.message = res.data.message;
        })
        .catch((err) => {
          this.active = true;
          let error = { err };
          this.message = error.err.response.data.message;
        });
    },

    selectedValue(itemSelected) {
      if (itemSelected.role === 5) {
        this.getQualityValues(itemSelected);
      } else if (itemSelected.role === 0) {
        this.getAgentRequest(itemSelected);
      }
    },

    selectedAdministrationValue(itemSelected) {
      this.sendRequestToAdministration(itemSelected);
    },

    getQualityValues(itemSelected) {
      let body = new FormData();

      body.append("request_ids[0]", this.selectId);
      body.append("quality[0]", itemSelected.id);

      axiosInstance
        .post(`/v2/employee/Requests/moveToQualityReqArray`, body, {
          headers: this.request_headers(),
        })
        .then((res) => {
          this.active = true;
          this.message = res.data.message;
        })
        .catch((err) => {
          this.active = true;
          let error = { err };
          this.message = error.err.response.data.message;
        });
    },

    getProductType() {
      let url = "/customer/SelectedProduct";
      axiosInstance.get(url).then((res) => {
        this.selected_products_list = res.data.payload;
      });
    },
    setTblData(res) {
      // console.log("res", res);
      this.$store.state.tableData.push({
        id: res.id,
        isSelected: false,
        "رقم الطلب": res.id,
        created_at: res.created_at ? formatDate(res.created_at) : "",
        type: res.type || "لا_يوجد",
        req_product_type: this.selected_products_list.find(item => item.id === res.req_product_type)?.value || "لا_يوجد",
        "استشاري المبيعات": res.user?.name,
        "customer_name": res.customer.name,
        "customer_mobile": res.customer.mobile,
        status: res.status,
        source: SourceValue(res.source),
        "تصنيف الاستشاري": res.class_id_agent_text,
        agent_notes: res.agent_notes,
        quality_notes: res.quality_notes,
        comment_date: res.comment_date,
        quacomment_date: res.quacomment_date,
        agent_date: res.agent_date ? formatDate(res.agent_date) : "",
        "هل تم استلامه من قبل الجوده":res.is_recieved_from_quality ? "نعم" : "لا",
        // res.user?.allow_recived && res.user?.allow_recived === 0 ? "لا" : "نعم",
        updated_at: res.updated_at ? formatDate(res.updated_at) : "",
        request_description: res.requestDescription?.option || res.request_description_other,
        situation_improve_date: res.situation_improve_date ? formatDate(res.situation_improve_date) : "",
        العمليات: res.sent_basket?.count,
      });
    },

    getCustomers() {
      axiosInstance.get("/employee/admin/getAllCustomer").then((res) => {
        this.customers = res.data.payload;
        this.customers.map((item) => {
          item["color"] = "red";
          item["text"] = item["name"];
          return item;
        });
      });
    },

    getTableData(count) {
      this.$store.state.tableData = [];
      this.loading = true;
      const pageNumber = Number(this.$store.state.counterOfShow);
      axiosInstance
        .get(`/v2/employee/Requests?type=customer_services_requests_processed&page=${count}&per_page=${pageNumber}`, {
          headers: this.request_headers(),
        })
        .then((res) => {
          res.data.payload.data.map((item) => {
            this.setTblData(item);
          });
          this.loading = false;
        });
    },

    handlePageNumber(val) {
      if (this.$store.state.isSearch === false) {
        this.getAllRequests(val);
      } else {
        this.searchRequest(val);
      }
    },

    searchRequest(page, type) {
      this.loading = true;
      if (type === "table") {
        this.$store.state.tableData = [];
      }

      if (page > 1 || type === "table") {
        this.$store.state.bodySearch.delete("page");
        this.$store.state.bodySearch.append("page", page);

        let url = `/v2/employee/Requests/search?type=1&per_page=${this.$store.state.counterOfShow}`;
        axiosInstance
          .post(url, this.$store.state.bodySearch, { headers: this.request_headers() })
          .then((res) => {
            this.$store.state.pagination = {
              limit: 3,
              count: res.data.payload.searched,
            };
            let response = res.data.payload.data.map((item) => {
              if (item.length === 0) {
                this.loading = false;
              }
              this.setTblData(item);
              item["starChecked"] = false;
              return item;
            });

            this.$store.state.allSearch.push(...response);
            this.removeDublicate(this.$store.state.allSearch);
            this.loading = false;
          });
      }
    },

    removeDublicate(array) {
      let uniqueArray = array.filter((item, index) => {
        return (
          index ===
          array.findIndex((obj) => {
            return obj.id === item.id;
          })
        );
      });
      this.$store.state.allData = uniqueArray;
    },

    getAllRequests(page) {
      if (
        this.$store.state.allData.length === 0 ||
        this.copySupportRequests.length === 0
      ) {
        this.$store.state.allLoading = true;
      }
      this.loadMoreData = true;
      axiosInstance
        .get(
          `/v2/employee/Requests?type=customer_services_requests_processed&page=${page}&per_page=${this.$store.state.counterOfShow}`
        )
        .then((res) => {
          this.$store.state.pagination = {
            limit: 3,
            count: res.data.payload.count_of_all,
          };
          let response = res.data.payload.data.map((item) => {
            this.setTblData(item);
            item["starChecked"] = false;
            return item;
          });

          this.allGetData.push(...response);
          this.removeDublicate(this.allGetData);
          this.copySupportRequests.push(...response);
        })
        .catch((err) => {
          this.$store.state.allLoading = false;
          this.loadMoreData = false;
        })
        .finally(() => {
          this.loadMoreData = false;
          this.$store.state.allLoading = false;
        });
    },

    handleChangeInput(row) {
      row["selected"] = !row["selected"];
      let findRow = this.selectedRows.findIndex((item) => item["id"] === row["id"]);
      if (findRow !== -1) {
        this.selectedRows.splice(findRow, 1);
      } else {
        this.selectedRows.push(row);
      }
    },
    resetSelectedItems() {
      this.selectedItems = [];
    },
  },
  created() {
    EventBus.$on('EmptySelectedRequests', this.resetSelectedItems);
    this.getCustomers();
    this.$store.state.tableData = [];
    this.$store.state.back = false;
    this.$store.state.isSearch = false;
    this.$store.state.bodySearch = new FormData();
    this.getProductType();
    this.getAllRequests(1);
    this.$store.state.startElement = [];
    this.selected_products_list = this.$store.state.selected_products;

    this.$store.state.views = "table";
  },
};
</script>

<style>
.button__back {
  width: 70px;
  height: 40px;
  border-radius: 5px;
  margin: 50px;
  color: white;
  background-color: #441545;
  direction: ltr;
}
/*
.new__request span,.anotherTypes__request span,.archive__request span{
  font-family: Dintext !important;
  font-size: 10px;
}
 */
.noData {
  display: flex;
  justify-content: center;
  font-size: 22px;
  color: #3f0e40;
  margin-top: 70px;
  font-weight: bold;
}
.v-data-table > .v-data-table__wrapper > table > tbody > tr > td span{
  font-family: Dintext !important;
}
.faild__request {
  border: 1px solid red;
  color: red;
  display: inline-block;
  padding: 0 3px 3px 3px;
  border-radius: 4px;
}

.archive__request {
  border: 1px solid #dbb622;
  color: #dbb622;
  display: inline-block;
  padding: 0 3px 3px 3px;
  border-radius: 4px;
}

.anotherTypes__request {
  border: 1px solid #ff7b1c;
  color: #ff7b1c;
  display: inline-block;
  padding: 0 3px 3px 3px;
  border-radius: 4px;
}

.new__request {
  border: 1px solid green;
  color: green;
  padding: 0 4px 4px 4px;
  border-radius: 4px;
}

.table__view .v-btn:not(.v-btn--round).v-size--small {
  min-width: auto !important;
}







.search-fields {
  display: flex;
  gap: 10px;
  align-items: center;
}

.action-buttons {
  margin-left: auto;
  display: flex;
  gap: 10px;
  align-items: center;
  position: absolute;
  left: 25px;
}

.sidebar {
  width: 300px;
  margin-right: 10px;
  border: 1px solid #ccc;
  padding: 10px;
  height: auto;
  overflow-y: auto;
}

.tab-with-icon {
  display: flex;
  align-items: center;
  gap: 8px;
}

.custom-text-field {
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 5px;
  background-color: #fff;
  flex: 1;
}

.custom-text-field .v-input__control {
  padding: 5px;
}

.filters-block {
  max-height: 700px;
  padding: 15px;
  overflow-y: auto;
}

/* .filters-content {
  display: flex;
  flex-direction: column;
  gap: 10px;
} */







.filters-block {
  background-color: #fff;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
  position: relative;
}

.filters-content {
  margin-top: 20px;
}

.close-filters {
  position: absolute;
  top: 10px;
  left: 10px;
}

h4 {
  color: #5a2d82;
  font-weight: bold;
}

.custom-phone-background .v-input__control .v-input__slot {
  background-color: white !important; /* تغيير اللون الخلفي */
  min-height: 48px !important;
}

.custom-txt-style-b{
  font-weight: bold;
  color: #0e807f;
}
.custom-txt-style-b-active{
  color: #451646;
}

.custom-txt-style-b-icon::before{
  font-weight: bold;
  color: #0e807f;
}
.custom-txt-style-b-icon-active::before{
  color: #451646;
}
</style>
